















import { Component, Vue, Prop } from 'vue-property-decorator';
import GlobalMixins from '../mixins';

@Component
export default class AppError extends GlobalMixins {
	@Prop({required: true}) title!: string
	@Prop({required: true}) text!: string
	@Prop({required: true}) buttonLabel!: string

	closeErrorModal(e: any) {
		if (e.target.classList.contains('error__wrapper')) {
			this.$emit('close')
		}
	}

	created() {
		document.addEventListener('keydown', e => {
			if (e.code === 'Escape') {
				this.$emit('close')
			}
		})
	}
}
